import type { Config } from 'tailwindcss';
import themer from 'tailwindcss-themer';

export default {
    content: [
        './index.html',
        './src/**/*.{vue,js,ts,jsx,tsx}',
    ],
    safelist: [
        {
            pattern: /col-span-(1|2|3|4|5|6|7|8|9|10|11|12)/,
        },
    ],
    mode: 'jit',
    theme: {
        fontSize: {
            9: '0.9rem',
            10: '1rem',
            11: '1.1rem',
            12: '1.2rem',
            13: '1.3rem',
            14: '1.4rem',
            15: '1.5rem',
            16: '1.6rem',
            17: '1.7rem',
            18: '1.8rem',
            20: '2rem',
            22: '2.2rem',
            24: '2.4rem',
            26: '2.6rem',
            28: '2.8rem',
            32: '3.2rem',
            38: '3.8rem',
            42: '4.2rem',
            56: '5.6rem',
            80: '8rem',
            96: '9.6rem',
        },
        screens: {
            xs: '0px',
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            xxl: '1536px',
        },
        zIndex: {
            menu: '1000',
            leftMenu: '1000',
            rightMenu: '1000',
            topMenu: '1500',
            dialog: '2000',
            confirmationDialog: '3000',
            spinner: '20000',
        },
        extend: {
            borderRadius: {
                10: '10px',
            },
            maxWidth: {
                sm: '32rem',
                md: '48rem',
                lg: '60rem',
            },
            margin: {
                15: '3.75rem',
                18: '4.5rem',
                26: '6.5rem',
                50: '5rem',
                80: '8rem',
                90: '9rem',
                95: '9.5rem',
                100: '10rem',
            },
            gridTemplateColumns: {
                '13': 'repeat(13, minmax(0, 1fr))',
                '14': 'repeat(14, minmax(0, 1fr))',
                '15': 'repeat(15, minmax(0, 1fr))',
            },
            minHeight: {
                160: '40rem',
            },
            height: {
                160: '40rem',
            },
        },
    },
    plugins: [
        themer({
            defaultTheme: {
                extend: {
                    colors: {
                        text: '#0E2D30',
                        border: 'rgb(235 235 235)',
                        shadow: '#0E2D30',
                        backdrop: '#0E2D30',
                        modalBackground: '#fff',

                        // StiftSelskab.nu brand palette (from brandguide)
                        brand: {
                            deep: '#0E2D30',      // Deep Foundation Green
                            momentum: '#43b681',  // Momentum Green (CTA)
                            haze: '#E0EAE9',      // Nordic Haze (bg)
                            mist: '#BBCAC7',      // Clarity Mist (border)
                            sage: '#899883',      // Muted Sage (secondary text)
                        },

                        // Remap legacy tokens so existing utility classes follow the brand
                        green: {
                            primary: '#43b681',
                            600: '#43b681',
                            700: '#43b681',
                        },

                        blue: {
                            primary: '#0E2D30',
                            50: '#E0EAE9',
                            100: '#BBCAC7',
                            600: '#0E2D30',
                            700: '#0E2D30',
                        },

                        elements: '#fff',
                        background: '#E0EAE9',


                        tabs: {
                            item: '#fff',
                            itemActive: '#43b681',
                            color: '#0E2D30',
                            activeColor: '#0E2D30',
                        },
                    },
                    fontFamily: {
                        sans: ['"Plus Jakarta Sans"', 'system-ui', '-apple-system', 'Segoe UI', 'sans-serif'],
                    },
                },
            },
        }),
    ],
} satisfies Config;